// One page per real job, at /our-work/<slug>. Built from Romeo's own
// photos and captions (backend/seed_data/portfolio_additions.json); keep the
// two in step. Only state what is true of the job. Add the town once known:
// it goes into the heading, title and description.

export const jobs = [
  {
    "id": "real-job-01-conservatory-windows",
    "slug": "conservatory-and-window-restoration",
    "title": "Conservatory and Window Restoration",
    "category": "Exterior Painting",
    "serviceAnchor": "exterior-painting",
    "town": null,
    "summary": "Timber conservatory and casement windows brought back from flaking paint and rot. Rotten timber cut back and repaired, filled and sanded, then primed and painted: the conservatory in a soft green, the windows and reveals in white. The gallery ends with how it looked before.",
    "photos": [
      {
        "src": "/images/portfolio/job01_01.jpg",
        "caption": "Timber conservatory finished in sage green, with the house's windows in white"
      },
      {
        "src": "/images/portfolio/job01_02.jpg",
        "caption": "Rear casement window finished in white gloss"
      },
      {
        "src": "/images/portfolio/job01_03.jpg",
        "caption": "Side of the conservatory after repainting in sage green"
      },
      {
        "src": "/images/portfolio/job01_04.jpg",
        "caption": "Conservatory frames and glazing bars repainted in sage green"
      },
      {
        "src": "/images/portfolio/job01_05.jpg",
        "caption": "Window and reveal repainted in white beside the conservatory"
      },
      {
        "src": "/images/portfolio/job01_06.jpg",
        "caption": "Conservatory roof line and frames after repainting"
      },
      {
        "src": "/images/portfolio/job01_07.jpg",
        "caption": "Conservatory side panels finished in sage green"
      },
      {
        "src": "/images/portfolio/job01_08.jpg",
        "caption": "Conservatory frames along the garden path after repainting"
      },
      {
        "src": "/images/portfolio/job01_09.jpg",
        "caption": "Rear window before, with worn paint and a stained sill"
      },
      {
        "src": "/images/portfolio/job01_10.jpg",
        "caption": "Window and door frame before, with flaking paint"
      },
      {
        "src": "/images/portfolio/job01_11.jpg",
        "caption": "Window sill before, with rot at the joint"
      },
      {
        "src": "/images/portfolio/job01_12.jpg",
        "caption": "Rotten sill timber exposed before repair"
      },
      {
        "src": "/images/portfolio/job01_13.jpg",
        "caption": "Conservatory frames before repainting"
      },
      {
        "src": "/images/portfolio/job01_14.jpg",
        "caption": "Conservatory glazing bars before, with faded paint"
      },
      {
        "src": "/images/portfolio/job01_15.jpg",
        "caption": "Conservatory corner before preparation"
      },
      {
        "src": "/images/portfolio/job01_16.jpg",
        "caption": "Glazing bars before, with peeling paint"
      },
      {
        "src": "/images/portfolio/job01_17.jpg",
        "caption": "Conservatory door frame before, with worn paint and metal hinge"
      },
      {
        "src": "/images/portfolio/job01_18.jpg",
        "caption": "Conservatory corner post before, with rot at the base"
      },
      {
        "src": "/images/portfolio/job01_19.jpg",
        "caption": "Bottom rail before, with flaking paint"
      },
      {
        "src": "/images/portfolio/job01_20.jpg",
        "caption": "Corner timber before, with rot and loose paint"
      },
      {
        "src": "/images/portfolio/job01_21.jpg",
        "caption": "Door frame before, with deep rot at the bottom"
      },
      {
        "src": "/images/portfolio/job01_22.jpg",
        "caption": "Glazing bars and sill before repainting"
      },
      {
        "src": "/images/portfolio/job01_23.jpg",
        "caption": "Conservatory door before, with worn paint"
      },
      {
        "src": "/images/portfolio/job01_24.jpg",
        "caption": "Bottom rail before, with weathered paint"
      }
    ]
  },
  {
    "id": "real-job-02-front-door-canopy",
    "slug": "front-elevation-doors-and-canopy",
    "title": "Front Elevation, Doors and Canopy",
    "category": "Exterior Painting",
    "serviceAnchor": "exterior-painting",
    "town": null,
    "summary": "Front of a house brought back to life: painted brickwork and walls, the concrete canopy made good and painted, the flat roof coated, and the front and side doors finished in high-gloss blue. The gallery runs from finished work, through the job in progress, to how it looked before.",
    "photos": [
      {
        "src": "/images/portfolio/job02_01.jpg",
        "caption": "Front elevation finished: painted walls, canopy and blue front door"
      },
      {
        "src": "/images/portfolio/job02_02.jpg",
        "caption": "Front door finished in high-gloss blue"
      },
      {
        "src": "/images/portfolio/job02_03.jpg",
        "caption": "Blue front door after repainting"
      },
      {
        "src": "/images/portfolio/job02_04.jpg",
        "caption": "Front door and porch after painting"
      },
      {
        "src": "/images/portfolio/job02_05.jpg",
        "caption": "Side door finished in high-gloss blue"
      },
      {
        "src": "/images/portfolio/job02_06.jpg",
        "caption": "Flat roof being coated"
      },
      {
        "src": "/images/portfolio/job02_07.jpg",
        "caption": "Side passage and canopy during the job"
      },
      {
        "src": "/images/portfolio/job02_08.jpg",
        "caption": "Door surround during preparation"
      },
      {
        "src": "/images/portfolio/job02_09.jpg",
        "caption": "Front door during painting, with floors sheeted"
      },
      {
        "src": "/images/portfolio/job02_10.jpg",
        "caption": "Front door with masking, mid-job"
      },
      {
        "src": "/images/portfolio/job02_11.jpg",
        "caption": "Concrete canopy before, with cracked and broken edges"
      },
      {
        "src": "/images/portfolio/job02_12.jpg",
        "caption": "Front entrance before painting"
      },
      {
        "src": "/images/portfolio/job02_13.jpg",
        "caption": "Front of the house before, with tired paint and canopy"
      },
      {
        "src": "/images/portfolio/job02_14.jpg",
        "caption": "Front elevation before work started"
      }
    ]
  },
  {
    "id": "real-job-03-garden-room-interior",
    "slug": "garden-room-kitchen-and-joinery",
    "title": "Garden Room, Kitchen and Joinery",
    "category": "Interior Painting",
    "serviceAnchor": "interior-painting",
    "town": null,
    "summary": "Interior redecoration across a garden room, kitchen and living spaces. The garden room's many timber windows and doors, the built-in cupboards and the window frames were finished in a soft plaster pink, with walls and ceilings refreshed throughout. The gallery ends with how the garden room looked before.",
    "photos": [
      {
        "src": "/images/portfolio/job03_01.jpg",
        "caption": "Garden room finished, with timber windows and doors in soft plaster pink"
      },
      {
        "src": "/images/portfolio/job03_02.jpg",
        "caption": "Kitchen window frame finished in soft plaster pink"
      },
      {
        "src": "/images/portfolio/job03_03.jpg",
        "caption": "Built-in cupboard finished in soft plaster pink"
      },
      {
        "src": "/images/portfolio/job03_04.jpg",
        "caption": "Hallway door and frame after painting"
      },
      {
        "src": "/images/portfolio/job03_05.jpg",
        "caption": "Built-in cupboard being finished"
      },
      {
        "src": "/images/portfolio/job03_06.jpg",
        "caption": "Garden room windows along the length of the room"
      },
      {
        "src": "/images/portfolio/job03_07.jpg",
        "caption": "Garden room with the roof lantern and doors to the garden"
      },
      {
        "src": "/images/portfolio/job03_08.jpg",
        "caption": "Garden room windows with blinds, during the job"
      },
      {
        "src": "/images/portfolio/job03_09.jpg",
        "caption": "Garden room from the kitchen end, during the job"
      },
      {
        "src": "/images/portfolio/job03_10.jpg",
        "caption": "Living room with wood burner, during the job"
      },
      {
        "src": "/images/portfolio/job03_11.jpg",
        "caption": "Kitchen during the job, with floors protected"
      },
      {
        "src": "/images/portfolio/job03_12.jpg",
        "caption": "Kitchen and garden room during the job"
      },
      {
        "src": "/images/portfolio/job03_13.jpg",
        "caption": "Garden room window and stay before"
      },
      {
        "src": "/images/portfolio/job03_14.jpg",
        "caption": "Garden room window and catches before"
      },
      {
        "src": "/images/portfolio/job03_15.jpg",
        "caption": "Window stay and frame before"
      },
      {
        "src": "/images/portfolio/job03_16.jpg",
        "caption": "Ceiling and walls before"
      },
      {
        "src": "/images/portfolio/job03_17.jpg",
        "caption": "Garden room before, with the roof lantern"
      },
      {
        "src": "/images/portfolio/job03_18.jpg",
        "caption": "Garden room side windows before"
      },
      {
        "src": "/images/portfolio/job03_19.jpg",
        "caption": "Garden room before, looking to the garden"
      },
      {
        "src": "/images/portfolio/job03_20.jpg",
        "caption": "Garden room windows before"
      },
      {
        "src": "/images/portfolio/job03_21.jpg",
        "caption": "Side window before"
      },
      {
        "src": "/images/portfolio/job03_22.jpg",
        "caption": "Window catch and frame before"
      }
    ]
  },
  {
    "id": "real-job-04-victorian-bay-front",
    "slug": "victorian-bay-fronted-house",
    "title": "Victorian Bay-Fronted House",
    "category": "Exterior Painting",
    "serviceAnchor": "exterior-painting",
    "town": null,
    "summary": "Front of a Victorian bay-fronted brick house repainted: the two-storey bay, window surrounds, sills and arched door surround, set off by the yellow front door. Moss and dirt were cleared from the bay tops before preparation, as the last photos show.",
    "photos": [
      {
        "src": "/images/portfolio/job04_01.jpg",
        "caption": "Victorian bay-fronted house after repainting"
      },
      {
        "src": "/images/portfolio/job04_02.jpg",
        "caption": "Arched door surround repainted, with the yellow front door"
      },
      {
        "src": "/images/portfolio/job04_03.jpg",
        "caption": "Painting the front with ladders and dust sheets down"
      },
      {
        "src": "/images/portfolio/job04_04.jpg",
        "caption": "Lower bay and sill after painting"
      },
      {
        "src": "/images/portfolio/job04_05.jpg",
        "caption": "Bay top before, covered in moss and dirt"
      },
      {
        "src": "/images/portfolio/job04_06.jpg",
        "caption": "Bay coping before cleaning"
      }
    ]
  },
  {
    "id": "real-job-05-hallway-stairs-bedrooms",
    "slug": "hallway-stairs-bedrooms-and-bay-room",
    "title": "Hallway, Stairs, Bedrooms and Bay Room",
    "category": "Interior Painting",
    "serviceAnchor": "interior-painting",
    "town": null,
    "summary": "A full interior refresh taking dark navy and teal walls to lighter colours: sage green below the dado rail with white above on the hallway, stairs and landings, soft blue in the bedroom, and a warm neutral in the bay-fronted room, with ceilings, cornicing and woodwork done throughout. The gallery runs from finished rooms, through the job in progress, to the dark walls before.",
    "photos": [
      {
        "src": "/images/portfolio/job05_01.jpg",
        "caption": "Staircase finished: sage green below the dado rail, white above"
      },
      {
        "src": "/images/portfolio/job05_02.jpg",
        "caption": "Stairs and landing in sage green and white"
      },
      {
        "src": "/images/portfolio/job05_03.jpg",
        "caption": "Hallway from the top of the stairs"
      },
      {
        "src": "/images/portfolio/job05_04.jpg",
        "caption": "Landing finished in sage green and white"
      },
      {
        "src": "/images/portfolio/job05_05.jpg",
        "caption": "Top landing in sage green and white"
      },
      {
        "src": "/images/portfolio/job05_06.jpg",
        "caption": "Staircase and banister from the landing"
      },
      {
        "src": "/images/portfolio/job05_07.jpg",
        "caption": "Hallway wall in sage green below the dado rail"
      },
      {
        "src": "/images/portfolio/job05_08.jpg",
        "caption": "Downstairs hallway in sage green and white"
      },
      {
        "src": "/images/portfolio/job05_09.jpg",
        "caption": "Bedroom finished in soft blue with white ceiling"
      },
      {
        "src": "/images/portfolio/job05_10.jpg",
        "caption": "Bedroom window wall in soft blue"
      },
      {
        "src": "/images/portfolio/job05_11.jpg",
        "caption": "Soft blue bedroom with white woodwork"
      },
      {
        "src": "/images/portfolio/job05_12.jpg",
        "caption": "Bay-fronted room finished in a warm neutral"
      },
      {
        "src": "/images/portfolio/job05_13.jpg",
        "caption": "Ceiling, cornicing and ceiling rose painted white"
      },
      {
        "src": "/images/portfolio/job05_14.jpg",
        "caption": "Corner of the bay-fronted room in a warm neutral"
      },
      {
        "src": "/images/portfolio/job05_15.jpg",
        "caption": "Bay-fronted room with fresh neutral walls"
      },
      {
        "src": "/images/portfolio/job05_16.jpg",
        "caption": "Hallway mid-change from navy to sage green"
      },
      {
        "src": "/images/portfolio/job05_17.jpg",
        "caption": "Navy wall being painted over with sage green"
      },
      {
        "src": "/images/portfolio/job05_18.jpg",
        "caption": "Navy bedroom with sample patches, during the job"
      },
      {
        "src": "/images/portfolio/job05_19.jpg",
        "caption": "Painting the cornice in the bay-fronted room"
      },
      {
        "src": "/images/portfolio/job05_20.jpg",
        "caption": "Teal bay-fronted room before"
      },
      {
        "src": "/images/portfolio/job05_21.jpg",
        "caption": "Teal wall with sample patches before"
      },
      {
        "src": "/images/portfolio/job05_22.jpg",
        "caption": "Navy bedroom with sample patches before"
      },
      {
        "src": "/images/portfolio/job05_23.jpg",
        "caption": "Navy bedroom wall before"
      }
    ]
  },
  {
    "id": "real-job-06-weatherboard-cottage",
    "slug": "weatherboard-cottage-restoration",
    "title": "Weatherboard Restoration",
    "category": "Exterior Painting",
    "serviceAnchor": "exterior-painting",
    "town": null,
    "summary": "Timber weatherboard cottage repainted front and back. Damaged boarding and window timber were repaired and prepared, then painted: white to the front with black windows and a red front door, black to the rear with white windows. The last photos show the rear boarding and window timber before.",
    "photos": [
      {
        "src": "/images/portfolio/job06_01.jpg",
        "caption": "Weatherboard cottage front in white with a red front door"
      },
      {
        "src": "/images/portfolio/job06_02.jpg",
        "caption": "Side of the cottage in white weatherboard"
      },
      {
        "src": "/images/portfolio/job06_03.jpg",
        "caption": "Window in black frame against white weatherboard"
      },
      {
        "src": "/images/portfolio/job06_04.jpg",
        "caption": "Rear of the cottage finished in black"
      },
      {
        "src": "/images/portfolio/job06_05.jpg",
        "caption": "Rear windows in white against black weatherboard"
      },
      {
        "src": "/images/portfolio/job06_06.jpg",
        "caption": "Rear courtyard after repainting"
      },
      {
        "src": "/images/portfolio/job06_07.jpg",
        "caption": "Rear gable in black weatherboard"
      },
      {
        "src": "/images/portfolio/job06_08.jpg",
        "caption": "Rear wall with white windows and door"
      },
      {
        "src": "/images/portfolio/job06_09.jpg",
        "caption": "Corner of the rear weatherboarding after painting"
      },
      {
        "src": "/images/portfolio/job06_10.jpg",
        "caption": "Rear boarding being prepared, with ladders up"
      },
      {
        "src": "/images/portfolio/job06_11.jpg",
        "caption": "Rear wall during preparation"
      },
      {
        "src": "/images/portfolio/job06_12.jpg",
        "caption": "Rear window before, with worn paint"
      },
      {
        "src": "/images/portfolio/job06_13.jpg",
        "caption": "Window timber before, with rot and flaking paint"
      }
    ]
  }
];

export const jobPath = (job) => `/our-work/${job.slug}`;
export const jobBySlug = (slug) => jobs.find((j) => j.slug === slug);
export const jobById = (id) => jobs.find((j) => j.id === id);
